(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('heroImage', function($location, resourceService, $route) {
    function getResource(k) {
        switch (k.toLowerCase()) {
            case 'rc':
                return resourceService.get('RECOMMENDEDHOTELSIN');
            case 'tr':
                return resourceService.get('TOPRATEDHOTELSIN');
            case 'bh':
                return resourceService.get('BUDGETHOTELSIN');
            case 'lh':
                return resourceService.get('LUXURYHOTELSIN');
            default:
                return `{0} ${resourceService.get('IN')} {1}`;
        }
    }

    function getArea() {
        switch ($route.current.area) {
            case 'hotels':
                return resourceService.get('HOTELS');
            case 'holidays':
                return resourceService.get('HOLIDAYS');
            case 'flights':
                return resourceService.get('FLIGHTS');
            case 'transfers':
                return resourceService.get('TRANSFERS');
        }
        return '';
    }
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'partials/home/directivetemplate?type=heroimage',
        link(scope, el, attrs) {
            scope.overrideOverlay = attrs.overrideOverlay === 'true';
            scope.overlayTitle = function() {
                if (scope.overrideOverlay) {
                    return getArea();
                }
                if (scope.destination == null) {
                    return '';
                }
                const k = $location.search().k;
                if (k == null || scope.destination.EstablishmentId > 0) {
                    return scope.destination.Title;
                }
                return String.format(getResource(k), getArea(), scope.destination.Title);
            };
        }
    };
});
})();
